import { render, staticRenderFns } from "./newprofile.vue?vue&type=template&id=9837811c&scoped=true"
import script from "./newprofile.vue?vue&type=script&lang=js"
export * from "./newprofile.vue?vue&type=script&lang=js"
import style0 from "./newprofile.vue?vue&type=style&index=0&id=9837811c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9837811c",
  null
  
)

export default component.exports